import * as React from 'react';
// import SwipeableViews from 'react-swipeable-views';
import Carousel from 'react-material-ui-carousel';

import Box from '@mui/material/Box';

import Image1 from '../../assets/card-1.jpg';
import Image2 from '../../assets/card-2.jpg';
import Image3 from '../../assets/card-3.jpg';


const TestimonialNodes = [{
    title: "",
    desc1: "My Sea Finance MA journey has been a fulfilling voyage with great opportunities to work alongside the different teams in Finance, providing a real breadth of exposure. The experience in each rotation has helped me to realize how different parts of the Finance ecosystem work together. Our trust in people and their abilities has instilled the confidence in me to explore, learn and grow as a person, and professionally, enabling me to ride on the waves as I sail further in my career.",
    desc2: "",
    desc3: "",
    name: "Teh Yong Wei, Graduated FMA, 2020",
    position1: "Nanyang Technological University, Accounting and Banking & Finance",
    position2: "",
    position3: "",
    img: Image1,
    bgColor: '#000084'
},{
    title: "",
    desc1: "Becoming an FMA has been an enriching odyssey. With a supportive and nurturing team that genuinely fosters growth and excellence, I was entrusted with meaningful and impactful projects. This also gave me the confidence to venture into uncharted waters and embrace continuous growth. I am grateful for this rewarding journey and I am excited for the opportunities that await me in the future!",
    desc2: "",
    desc3: "",
    name: "Alvis Kok, FMA 2022",
    position1: "National University of Singapore, Accountancy & Finance",
    position2: "",
    position3: "",
    img: Image2,
    bgColor: '#478EF7'
},{
    title: "",
    desc1: "My experience so far as an FMA has been very fulfilling! Sailing through the dynamic economic environment brought both rewards and challenges. The opportunities to explore various functions not only gave me a comprehensive understanding of the finance department, but also challenged me to learn and contribute quickly. Most importantly, the supportive environment and mentorship also fueled my continuous growth and learning in my professional career.",
    desc2: "",
    desc3: "",
    name: "Lim Sze Leng, FMA 2022",
    position1: "Singapore Management University, Accountancy",
    position2: "",
    position3: "",
    img: Image3,
    bgColor: '#00E8FF'
}];

function CarouselCard(props){
    return(
        <Box className="card">
            <Box className="content-desc" sx={{
                        backgroundColor:`${props.item.bgColor}`,
                        // '@media(max-width: 821px)': {
                        //     backgroundColor:'#fff',
                        //     color: 'rgba(0,0,0,.54)'
                        // }
                        }}>
                <Box className="content-desc-text">
                <h4 className="title">{props.item.title}</h4>
                <p className="desc">{props.item.desc1}</p>
                {/* <p className="desc">{props.item.desc2}</p>
                <p className="desc">{props.item.desc3}</p> */}
                <p className="name">{props.item.name}</p>
                <p className="position">{props.item.position1}</p>
                {/* <p className="position">{props.item.position2}</p>
                <p className="position">{props.item.position3}</p> */}
                </Box>
            </Box>
            <Box className="content-img" sx={{background: `url(${props.item.img}) center 0 no-repeat;`}}>
                <Box className="content-img-linear"></Box>            
            </Box>
        </Box>
    )
}

export default function Testimonial(){
    return (
        <Box className="testimonial">
            <h2 className="section-title">Life @ Sea Finance!</h2>
            <Box className="carousel-wrapper">
                <Box className="carousel">

                    <Carousel animation="slide" indicators={false} interval='3000' duration='700' navButtonsAlwaysVisible={true} 
                        navButtonsWrapperProps={{
                            style: {
                                margin: '10px'
                            },
                            className : "nav-button-wrapper"
                        }}
                        navButtonsProps={{
                            style: {
                                backgroundColor: 'transparent',
                                color:'black',
                            }
                        }} > 
                        {
                            TestimonialNodes.map( (item,i) => <CarouselCard key={i} item={item} /> )
                        }
                    </Carousel>

                </Box>
            </Box>
        </Box>
            
    );
}